(() => {
  const key = 'mitoru-wishlist';
  const header = document.querySelector('.site-header');
  const headerSection = header?.closest('.shopify-section');
  const emptyState = () => ({ products: [], releases: [] });
  const getState = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      if (Array.isArray(value)) return { products: value, releases: [] };
      return { ...emptyState(), ...value };
    } catch (_) { return emptyState(); }
  };
  const setState = (state) => localStorage.setItem(key, JSON.stringify(state));
  const updateButtons = () => {
    const state = getState();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = state.products.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', saved);
      button.textContent = saved ? 'Gemerkt' : 'Merken';
    });
    document.querySelectorAll('[data-wishlist-release]').forEach((button) => {
      const saved = state.releases.some((release) => release.id === button.dataset.releaseId);
      button.setAttribute('aria-pressed', saved);
      button.textContent = saved ? 'Gemerkt' : 'Neuheit merken';
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const state = getState();
    state.products = state.products.includes(handle) ? state.products.filter((item) => item !== handle) : [...state.products, handle];
    setState(state); updateButtons(); window.dispatchEvent(new CustomEvent('mitoru:wishlist-change'));
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-release]');
    if (!button) return;
    const release = { id: button.dataset.releaseId, title: button.dataset.releaseTitle, url: button.dataset.releaseUrl, status: button.dataset.releaseStatus };
    if (!release.id || !release.title) return;
    const state = getState();
    state.releases = state.releases.some((item) => item.id === release.id) ? state.releases.filter((item) => item.id !== release.id) : [...state.releases, release];
    setState(state); updateButtons(); window.dispatchEvent(new CustomEvent('mitoru:wishlist-change'));
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mobile-menu-toggle]');
    if (!trigger) return;
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    const isOpening = menu.hasAttribute('hidden');
    if (isOpening) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', '');
    if (isOpening) header?.classList.remove('site-header--hidden');
    trigger.setAttribute('aria-expanded', String(isOpening));
  });
  if (header && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const getScrollY = () => document.documentElement.scrollTop || window.scrollY;
    let previousScrollY = getScrollY();
    let scrollFrame;
    const updateHeader = () => {
      const currentScrollY = getScrollY();
      const mobileMenu = header.querySelector('[data-mobile-menu]');
      if (currentScrollY < 80 || mobileMenu && !mobileMenu.hasAttribute('hidden')) {
        headerSection?.classList.remove('site-header-section--pinned');
        header.classList.remove('site-header--hidden');
      } else {
        headerSection?.classList.add('site-header-section--pinned');
        if (currentScrollY > previousScrollY) {
          header.classList.add('site-header--hidden');
        } else if (currentScrollY < previousScrollY) {
          header.classList.remove('site-header--hidden');
        }
      }
      previousScrollY = currentScrollY;
      scrollFrame = undefined;
    };
    window.addEventListener('scroll', () => {
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateHeader);
    }, { passive: true });
  }
  document.addEventListener('DOMContentLoaded', updateButtons);

  const formatMoney = (cents, currency) => (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'EUR' });
  const escape = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' })[character]);
  const drawer = document.querySelector('[data-cart-drawer]');
  const renderCart = (cart) => {
    if (!drawer) return;
    const items = drawer.querySelector('[data-cart-drawer-items]');
    const empty = drawer.querySelector('[data-cart-drawer-empty]');
    const footer = drawer.querySelector('[data-cart-drawer-footer]');
    items.innerHTML = cart.items.map((item) => '<article class="cart-drawer__item"><a href="' + escape(item.url) + '">' + (item.image ? '<img src="' + escape(item.image) + '" alt="' + escape(item.product_title) + '">' : '') + '</a><div><h3><a href="' + escape(item.url) + '">' + escape(item.product_title) + '</a></h3><p>' + item.quantity + ' × ' + escape(formatMoney(item.final_price, cart.currency)) + '</p></div></article>').join('');
    empty.hidden = cart.item_count > 0; footer.hidden = cart.item_count === 0;
    const total = drawer.querySelector('[data-cart-drawer-total]'); if (total) total.textContent = formatMoney(cart.total_price, cart.currency);
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; count.setAttribute('aria-label', String(cart.item_count) + ' Artikel'); });
  };
  const openDrawer = async () => {
    if (!drawer) return;
    const cart = await fetch('/cart.js').then((response) => response.json()); renderCart(cart); drawer.showModal();
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-trigger]');
    if (!trigger || !drawer) return;
    event.preventDefault(); openDrawer().catch(() => { window.location.assign(trigger.href); });
  });
  document.addEventListener('click', (event) => { if (event.target.closest('[data-cart-close]')) drawer?.close(); });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.product-form');
    if (!form || !drawer || !window.fetch) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]'); if (submit) submit.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Cart update failed');
      await openDrawer();
    } catch (_) { form.submit(); } finally { if (submit) submit.disabled = false; }
  });
})();
